export default "-- ClickBench Q2\nselect sum(advengineid), count(*), avg(resolutionwidth)\nfrom hits;";